<script>
export default {

}
</script>

<template>
  <p>Hello World</p>
</template>

<style scoped>

</style>
